import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    customBlue: string;
    customGray: string;
    buttonBlue: string;
  }
  interface PaletteOptions {
    customBlue: string;
    customGray: string;
    buttonBlue: string;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    customBlue: true;
    customGray: true;
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    buttonBlue: true;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF'
    },
    secondary: {
      main: '#A3D1FF'
    },
    background: {
      default: '#011A2D',
      paper: '#1A1A1A'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#A3D1FF'
    },
    customBlue: '#87BEFF',
    customGray: '#D9D9D9',
    buttonBlue: '#297DE0'
  },
  typography: {
    fontFamily: '"Outfit", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600
    },
    body1: {
      fontSize: '1rem'
    },
    button: {
      textTransform: 'none'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem'
        }
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        groupedHorizontal: {
          '&:first-of-type': {
            borderTopRightRadius: '20rem',
            borderBottomRightRadius: '20rem',
            borderTopLeftRadius: '20rem',
            borderBottomLeftRadius: '20rem'
          },
          '&:last-of-type': {
            borderTopRightRadius: '20rem',
            borderBottomRightRadius: '20rem',
            borderTopLeftRadius: '20rem',
            borderBottomLeftRadius: '20rem'
          }
        }
      }
    }
  }
});

export default theme;
